/**
 * Extracts the portion of the error message after the first colon, if available.
 * @param {string} errorMessage - The full error message string.
 * @returns {string} - The extracted message after the first colon, or the original message if no colon is found.
 */
export const extractErrorMessage = (errorMessage: string): string =>
  errorMessage.split(/:(.*)/s)[1]?.trim() ?? errorMessage;
